/* global TweenMax, Power2, Cleave */


// appliaction landing
$('body').on('click', '.application-section.waiver', function() {
    var $this = $(this);

    $('.deposit-terms, .deposit-terms-overlay').addClass('visible');
    $('.deposit-terms .agree').attr('href', $this.attr('href'));

    return false;
});

$('body').on('click', '.close-deposit-terms', function () {
    $('.deposit-terms, .deposit-terms-overlay').removeClass('visible');
    return false;
});

$('body').on('click', '.deposit-terms .scroll-terms', function () {
    var height = $('.deposit-terms .terms-outer-wrapper .terms-wrapper').height();
    $('.deposit-terms .terms-outer-wrapper').animate({
        scrollTop: height
    }, 300);
    return false;
});

$('.deposit-terms .terms-outer-wrapper').scroll(function () {
    var scrollTop = $('.deposit-terms .terms-outer-wrapper').scrollTop();

    var height = $('.deposit-terms .terms-outer-wrapper').height();
    var scrollHeight = $('.deposit-terms .terms-outer-wrapper .terms-wrapper').height() - height;
    scrollHeight -= $('.scroll-terms-wrapper').height();

    if (scrollTop >= scrollHeight) {
        $('.scroll-terms-wrapper').addClass('hidden');
    } else {
        $('.scroll-terms-wrapper').removeClass('hidden');
    }

    return false;
});




var payload = {};
var sliding = false;

// an input question
function validateEmail(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}

function validateInput(input) {
    console.log('validate input');
    var question = input.parents('.question');
    var value = $('input', input).val();

    input.removeClass('filled');
    if(value !== '') {
        input.addClass('filled');
    }

    if(question.attr('data-validate')) {
        var validations = JSON.parse(question.attr('data-validations'));
        
        // loop through the validation errors 
        $.each(validations, function(index, validation) {
            // console.log(validation);
            // reset the question error/success
            question.removeClass('error');
            question.removeClass('success');

            // if we have a required validation 
            if(validation.required) {
                if(value === '') {
                    if (validation.error) {
                        if (validation.error_message) {
                            question.addClass('error');
                            question.find('.message').html(validation.error_message);
                        }
                        return false;
                    }
                }

                if (validation.success) {
                    question.addClass('success');
                    question.find('.message').html(validation.success_message);
                }
            }
            
            // if we have a min validation
            if(validation.min) {
                // console.log(value.length, validation.min, validation.error);
                if (value.length < validation.min) {
                    if (validation.error) {
                        if (validation.error_message) {
                            question.addClass('error');
                            question.find('.message').html(validation.error_message);
                        }
                        return false;
                    }
                }
                
                if (value.length >= validation.min) {
                    if (validation.success) {
                        question.addClass('success');
                        question.find('.message').html(validation.success_message);
                    }
                }
            }

            // if we have an email validation 
            if(validation.email) {
                if (!validateEmail(value)) {
                    if (validation.error) {
                        if (validation.error_message) {
                            question.addClass('error');
                            question.find('.message').html(validation.error_message);
                        }
                        return false;
                    }
                }

                if (validation.success) {
                    question.addClass('success');
                    question.find('.message').html(validation.success_message);
                }
            }
        });

        return false;
    }

    question.removeClass('error');
    question.addClass('success');
}

function updateToolTip(tooltip) {
    if (tooltip) {
        TweenMax.to($('.application .tool-tip'), 0.25, {
            scale: 1,
            autoAlpha: 1,
            zIndex: -1
        });
        $('.application .tool-tip .tip span').html(tooltip);
    } else {
        TweenMax.to($('.application .tool-tip'), 0.25, {
            scale: 0,
            autoAlpha: 0,
            zIndex: -1
        });
    }
}

function updateQuestionProgress() {
    var totalQuestions = $('.question').length;

    // make sure we are not counting the loadings
    var loadingQuestions = $('.question.loading').length;
    totalQuestions = totalQuestions - loadingQuestions;

    // get the succces questions
    var successQuestions = $('.question.success').length;
    console.log(totalQuestions, successQuestions);
    
    // calcuate the total progress 
    var percentCompleted = (successQuestions * 100) / totalQuestions;
    
    // set thte progress
    $('.section-progress .progress').css({
        width: percentCompleted + '%'
    });

    // TEMP
    console.log('payload', payload);
}

function nextQuestion(questions, animate = true) {
    // console.log('next');
    if (sliding) {
        return false;
    }

    var active;
    var next;
    sliding = true;

    active = $('.intro.active, .question.active', questions);

    // if (active.is(':last-child')) {
    //     next = $('.intro, .question', questions).first();
    // } else {
    //     next = active.next();
    // }

    if (active.is(':last-child')) {
        if($('.application').attr('data-next')) {
            if ($('.application').attr('data-next_waiver')) {
                $('.deposit-terms, .deposit-terms-overlay').addClass('visible');
                $('.deposit-terms .agree').attr('href', $('.application').attr('data-next'));
                return false;
            }

            window.location.href = $('.application').attr('data-next');
            return false;
        }

        sliding = false;
        return false;
    }

    // next = active.next();
    // next = active.nextAll(':not(.hidden)').filter(':first');
    next = active.nextAll(':not(.hidden)').first();

    TweenMax.set(next, {
        x: questions.width()
    });

    if(!animate) {
        TweenMax.set(active,{
            x: - questions.width()
        });

        // on start
        // update the questions height
        TweenMax.set(questions, {
            height: active.innerHeight() >= (next.innerHeight() + $('.suggestions', next).height()) ? active.innerHeight() : (next.innerHeight() + $('.suggestions', next).height())
        });

        if (!next.is(':first-child')) {
            // $('.application .previous-question').show();
            TweenMax.to($('.application .previous-question'), 0.25, {
                width: 40
            });
        }

        // hide the tool tip
        updateToolTip(next.attr('data-tooltip'));

        // update the question info
        $.each(payload, function (name, value) {
            // console.log(name, value);
            if (next.find('h4').length) {
                var h4 = next.find('h4').html();
                h4 = h4.replace(`%${name}%`, value);
                next.find('h4').html(h4);
            }

            // the p
            if (next.find('p').length) {
                var p = next.find('p').html();
                p = p.replace(`%${name}%`, value);
                next.find('p').html(p);
            }

            // update the input placeholder
            if (next.find('input').length) {
                var placeholder = next.find('input').attr('placeholder');
                if (placeholder) {
                    placeholder = placeholder.replace(`%${name}%`, value);
                    next.find('input').attr('placeholder', placeholder);
                }
            }
        });


        TweenMax.set(next, {
            x: 0
        });

        // console.log('end');
        active.removeClass('active');
        next.addClass('active');
        sliding = false;

        // update the questions height
        TweenMax.set(questions, {
            height: (next.innerHeight() + $('.suggestions', next).height())
        });

        if ($('input', next).length) {
            $('input', next).focus();
        }

        // if the active question is a loading question
        if (active.hasClass('loading')) {
            active.remove();
        }

        return false;
    }

    TweenMax.to(active, 0.5, {
        x: - questions.width(),
        // ease: Power0.easeNone
        ease: Power2.easeInOut
    });

    TweenMax.to(next, 0.5, {
        x: 0,
        // ease: Power0.easeNone,
        ease: Power2.easeInOut,
        onStart: function () {
            // console.log('start');

            // update the questions height
            TweenMax.set(questions, {
                height: active.innerHeight() >= (next.innerHeight()+$('.suggestions', next).height()) ? active.innerHeight() : (next.innerHeight()+$('.suggestions', next).height())
            });

            if (!next.is(':first-child')) {
                // $('.application .previous-question').show();
                TweenMax.to($('.application .previous-question'), 0.25, {
                    width: 40
                });
            }

            // hide the tool tip
            updateToolTip(next.attr('data-tooltip'));

            // update the question info
            $.each(payload, function (name, value) {
                // console.log(name, value);
                if (next.find('h4').length) {
                var h4 = next.find('h4').html();
                    h4 = h4.replace(`%${name}%`, value);
                    next.find('h4').html(h4);
                }

                // the p
                if (next.find('p').length) {
                var p = next.find('p').html();
                    p = p.replace(`%${name}%`, value);
                    next.find('p').html(p);
                }

                // update the input placeholder
                if (next.find('input').length) {
                    var placeholder = next.find('input').attr('placeholder');
                    if(placeholder) {
                        placeholder = placeholder.replace(`%${name}%`, value);
                        next.find('input').attr('placeholder', placeholder);
                    }
                }
            });
        },
        onComplete: function () {
            // console.log('end');
            active.removeClass('active');
            next.addClass('active');
            sliding = false;

            // update the questions height
            TweenMax.set(questions, {
                height: (next.innerHeight()+$('.suggestions', next).height())
            });

            if($('input', next).length) {
                $('input', next).focus();
            }

            // if the active question is a loading question
            if(active.hasClass('loading')) {
                active.remove();
            }
        }
    });
}

function previousQuestion(questions) {
    if (sliding) {
        return false;
    }

    var active;
    var prev;
    sliding = true;

    active = $('.intro.active, .question.active', questions);

    // if (active.is(':first-child')) {
    //     prev = $('.intro, .question', questions).last();
    // } else {
    //     prev = active.prev();
    // }

    if (active.is(':first-child')) {
        sliding = false;
        return false;
    }

    // prev = active.prev();
    prev = active.prevAll(':not(.hidden)').first();

    TweenMax.set(prev, {
        x: -questions.width()
    });

    TweenMax.to(active, 0.5, {
        x: questions.width(),
        // ease: Power0.easeNone
        ease: Power2.easeInOut
    });

    TweenMax.to(prev, 0.5, {
        x: 0,
        // ease: Power0.easeNone,
        ease: Power2.easeInOut,
        onStart: function () {
            // console.log('start');

            // update the questions height
            TweenMax.set(questions, {
                height: active.innerHeight() >= (prev.innerHeight() + $('.suggestions', prev).height()) ? active.innerHeight() : (prev.innerHeight() + $('.suggestions', prev).height())
            });

            if (prev.is(':first-child')) {
                // $('.application .previous-question').hide();
                TweenMax.to($('.application .previous-question'), 0.25, {
                    width: 0
                });
            }

            // hide the tool tip
            updateToolTip(prev.attr('data-tooltip'));
        },
        onComplete: function () {
            // console.log('end');

            // update the questions height
            TweenMax.set(questions, {
                height: prev.innerHeight() + $('.suggestions', prev).height()
            });

            active.removeClass('active');
            prev.addClass('active');
            sliding = false;

            // if the active question is a loading question
            if(active.hasClass('loading')) {
                active.remove();
            }
        }
    });
}

function setupPhone(question) {
    var input = $('input', question);

    new Cleave(input[0], {
        phone: true,
        phoneRegionCode: 'US'
    });
}

function setupCreditCard(question) {
    var creditCard = $('.credit-card', question);
    var input = $('input', question);

    new Cleave(input[0], {
        creditCard: true,
        onCreditCardTypeChanged: function (type) {
            creditCard.attr('data-type', type);
        }
    });
}

function setupExpiry(question) {
    var input = $('input', question);

    new Cleave(input[0], {
        date: true,
        datePattern: ['m', 'y']
    });
}

function setupCVV(question) {
    var input = $('input', question);

    new Cleave(input[0], {
        numericOnly: true,
        delimiter: '',
        blocks: [3, 1]
    });
}

function setupCalendar(question) {
    var calendar = $('.calendar', question);

    $('[data-toggle="datepicker"]', question).datepicker({
        autoShow: true,
        inline: true,
        container: $('.datepicker', question),
        format: 'yyyy-mm-dd',
        autoHide: false,
        date: calendar.attr('data-initial_date') ? calendar.attr('data-initial_date') : null,
        startDate: calendar.attr('data-start_date') ? calendar.attr('data-start_date') : null,
        endDate: calendar.attr('data-end_date') ? calendar.attr('data-end_date') : null
    });
    $('[data-toggle="datepicker"]', question).datepicker('reset');

    $('[data-toggle="datepicker"]', question).on('pick.datepicker', function(e) {
        console.log(e);
        if($('input', calendar).val()) {
            question.addClass('success');
            question.removeClass('error');

            if(calendar.attr('data-auto_next')) {
                $('.application .next-question').trigger('click');
            }
        }
    });
}

// $().on('pick.datepicker', function (e) {
//     console.log(e);
// //   if (e.date < new Date()) {
// //     e.preventDefault(); // Prevent to pick the date
// //   }
// });

// setup the sliders
function setupQuestions(questions) {
    // set the questions width
    TweenMax.set($('.intro, .question', questions), { x: questions.width() });

    if($('.question.success', questions).length) {
        updateQuestionProgress();

        // get the last success question
        var last = $('.question.success', questions).last();
        if (!last.is(':last-child')) {
            // add the active to the next question
            last.next().addClass('active');
        } else {
            // set the first question to active
            $('.intro, .question', questions).first().addClass('active');
        }
    } else {
        // set the first question to active
        $('.intro, .question', questions).first().addClass('active');
    }

    // set the active question to the left
    TweenMax.set($('.intro.active, .question.active', questions), { x: 0 });

    // set the height of the questions
    TweenMax.set(questions, {
        height: $('.intro.active, .question.active', questions).height()
    });

    // update the tooltip
    updateToolTip($('.intro.active, .question.active', questions).attr('data-tooltip'));
}

$(window).on('resize', function() {
    var questions = $('.questions-wrapper');
    // update the left of the questions
    TweenMax.set($('.intro, .question', questions), { x: questions.width() });

    // fix the questions to 0
    TweenMax.set($('.intro.active, .question.active', questions), { x: 0 });

    // update the questions height
    TweenMax.set(questions, {
        height: $('.intro.active, .question.active', questions).innerHeight()
    });
});

$('.questions-wrapper').each(function() {
    var slider = $(this);

    // setup all the phone inputs
    $('.question .phone', slider).each(function () {
        var question = $(this).parents('.question');
        setupPhone(question);
    });

    // setup all the credit card inputs
    $('.question .credit-card', slider).each(function() {
        var question = $(this).parents('.question');
        setupCreditCard(question);
    });

    // setup all the expiry inputs
    $('.question .expiry', slider).each(function () {
        var question = $(this).parents('.question');
        setupExpiry(question);
    });

    // setup all the cvv inputs
    $('.question .cvv', slider).each(function () {
        var question = $(this).parents('.question');
        setupCVV(question);
    });

    //setup all the calendar questions
    $('.question .calendar', slider).each(function () {
        var question = $(this).parents('.question');
        setupCalendar(question);
    });

    // setup trip
    // setup long text

    // mobile only
    $('.question:not([data-mobile_only=""])', slider).each(function () {
        var question = $(this);
        // console.log(question.attr('data-question'));
        if($(window).width() >= 720) {
            question.addClass('hidden');
        }
    });

    setupQuestions(slider);
});

function inputQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="input">
            <input type="${data.input.type}" autocomplete="off" name="${data.input.name}" placeholder="${data.input.placeholder}" value="${data.input.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function phoneQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="phone">
            <input type="${data.phone.type}" autocomplete="off" name="${data.phone.name}" placeholder="${data.phone.placeholder}" value="${data.phone.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function creditCardQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="credit-card">
            <div class="icons">
                <figure class="icon" data-type="jcb"><img src="images/icons/jcb.svg" alt="jcb"></figure>
                <figure class="icon" data-type="diners"><img src="images/icons/diners.svg" alt="diners"></figure>
                <figure class="icon" data-type="discover"><img src="images/icons/discover.svg" alt="discover"></figure>
                <figure class="icon" data-type="amex"><img src="images/icons/amex.svg" alt="amex"></figure>
                <figure class="icon" data-type="mastercard"><img src="images/icons/mastercard.svg" alt="mastercard"></figure>
                <figure class="icon" data-type="visa"><img src="images/icons/visa.svg" alt="visa"></figure>
                <figure class="icon" data-type="card"><img src="images/icons/card.svg" alt="card"></figure>
            </div>
            <input type="${data.credit_card.type}" autocomplete="off" name="${data.credit_card.name}" placeholder="${data.credit_card.placeholder}" value="${data.credit_card.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function expiryQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="expiry">
            <input type="${data.expiry.type}" autocomplete="off" name="${data.expiry.name}" placeholder="${data.expiry.placeholder}" value="${data.expiry.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function cvvQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="cvv">
            <input type="${data.cvv.type}" autocomplete="off" name="${data.cvv.name}" placeholder="${data.cvv.placeholder}" value="${data.cvv.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function customSelectQuestion(data) {

    var options = '';
    $.each(data.custom_select.options, function(index, option) {
        options += `<li>
        <a href="" class="select-option ${option.selected ? 'selected' : ''}" data-generate_questions="${option.generate_questions ? option.generate_questions : ''}" data-questions_location="${option.questions_location ? option.questions_location : ''}" data-value="${option.value}" data-shortcut="${option.shortcut ? option.shortcut : ''}">
        
            ${option.icon ? '<figure class="icon"><img src="images/icons/'+option.icon+'" alt="'+option.icon+'"></figure>' : ''}
            <span class="selected icon-complete"></span>
            ${option.shortcut ? '<span class="shortcut">'+option.shortcut+'</span>' : ''}
            
            <div class="label">
                ${option.label}
                ${option.hint ? '<span class="hint">' + option.hint+'</span>' : ''}
            </div>
        </a>
    </li>`;
    });

    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="custom-select" data-name="${data.custom_select.name}" data-multiple="${data.custom_select.multiple ? true : ''}" data-auto_next="${data.custom_select.auto_next ? true : ''}">
            <ul class="options">
                ${options}
            </ul>
        </div>
    </div>`;
}

function selectQuestion(data) {

    var options = '';
    $.each(data.select.options, function (index, option) {
        options += `<option
        data-generate_questions="${option.generate_questions ? option.generate_questions : ''}"
        data-questions_location="${option.questions_location ? option.questions_location : ''}"
        ${data.select.value = option.value ? 'selected' : ''}
        value="${option.value}">
            ${option.label}
        </option>`;
    });

    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="select" data-auto_next="${data.select.auto_next ? true : ''}">
            <select name="${data.select.name}">
                <option value="" disabled ${!data.select.value ? 'selected' : ''}>${data.select.placeholder}</option>
                ${options}
            </select>

            <nav class="select-nav">
                <div class="open-select icon-arrow-down"></div>
            </nav>

            <div class="message"></div>
        </div>
    </div>`;
}

function suggestionQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div
            class="suggestion"
            data-suggestion="${data.suggestion.suggestion}"
            data-suggest_after="${data.suggestion.suggest_after}"
        >
            <input type="text" autocomplete="off" name="${data.suggestion.name}" placeholder="${data.suggestion.placeholder}" value="${data.suggestion.value}">
            <nav class="input-nav">
                <a href="" class="cancel-input icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
                <a href="" class="input-next-question icon-next"></a>
            </nav>
            <div class="message"></div>

            <div class="suggestions">
                <ul></ul>
            </div>
        </div>
    </div>`;
}

function calendarQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="calendar"
            data-start_date="${data.calendar.start_date}"
            data-end_date="${data.calendar.end_date}"
            data-initial_date="${data.calendar.initial_date}"
            data-auto_next="${data.calendar.auto_next ? true : ''}"
            >
            <input type="hidden" name="${data.calendar.name}" data-toggle="datepicker" data-default_date="${data.calendar.value}" value="${data.calendar.value}">
            <div class="datepicker"></div>
        </div>
    </div>`;
}

function tripQuestion(data) {
    return `<div class="trip" data-name="${data.name}">
        <a href="" class="choose-trip">
            <div class="icon">
                <div class="icon-add-light"></div>
            </div>

            <p>Choose a Trip</p>
        </a>
    </div>`;
}

function textareaQuestion(data) {
    return `<div class="question-wrapper">
        <h4>${data.question}</h4>
        <p>${data.hint}</p>

        <div class="textarea">
            <textarea class="auto-expand" autocomplete="off" rows="1" data-min-rows="1" name="${data.textarea.name}" placeholder="${data.textarea.placeholder}">${data.textarea.value}</textarea>
            <nav class="textarea-nav">
                <a href="" class="cancel-textarea icon-close"></a>
                <a href="" class="placeholder-icon icon-keyboard"></a>
            </nav>
            <div class="message"></div>
        </div>
    </div>`;
}

function addQuestions(dataSource, element, location) {
    console.log(location);
    var questions = [];
    var insertAfter = element;

    $.each(dataSource, function(index, data) {

        var question = $('<div>', {
            class: `question ${data.required ? 'required' : ''} ${data.success ? 'success' : ''}`,
            'data-question': data.id,
            'data-validate': data.validate ? true : '',
            'data-mobile_only': data.mobile_only ? true : '',
            'data-desktop_only': data.desktop_only ? true : '',
            'data-validations': JSON.stringify(data.validations),
            'data-tooltip': data.tooltip ? data.tooltip : ''
        });

        if(data.input) {
            question.append(inputQuestion(data));
        }

        if (data.phone) {
            question.append(phoneQuestion(data));
            setupPhone(question);
        }

        if (data.credit_card) {
            question.append(creditCardQuestion(data));
            setupCreditCard(question);
        }

        if (data.expiry) {
            question.append(expiryQuestion(data));
            setupExpiry(question);
        }

        if (data.cvv) {
            question.append(cvvQuestion(data));
            setupCVV(question);
        }

        if(data.custom_select) {
            question.append(customSelectQuestion(data));
        }

        if(data.select) {
            question.append(selectQuestion(data));
        }

        if(data.suggestion) {
            question.append(suggestionQuestion(data));
        }

        if (data.calendar) {
            question.append(calendarQuestion(data));
            setupCalendar(question);
        }

        if (data.trip) {
            question.append(tripQuestion(data));
        }

        if(data.textarea) {
            question.append(textareaQuestion(data));
        }

        // mobile only
        if (data.mobile_only) {
            if ($(window).width() >= 720) {
                question.addClass('hidden');
            }
        }

        questions.push(question);
    });

    $.each(questions, function() {
        var $this = $(this);

        // insert after the last insert
        insertAfter.after($this);

        // update the position of the question
        TweenMax.set($this, { x: $('.questions-wrapper').width() });

        // update the insert after
        insertAfter = $this;
    });

    // update the question progress
    updateQuestionProgress();

    // console.log(element);
    // console.log('has active', element.hasClass('active'));
    // console.log('next loading', $('.intro.active, .question.active', $('.application .questions-wrapper')).next().hasClass('loading'));

    var activeIndex = $('.intro.active, .question.active', $('.application .questions-wrapper')).index();
    var loadingIndex = element.index();

    if((activeIndex + 1) == loadingIndex) {
        console.log('slide next');
        
        if(sliding) {
            setTimeout(() => {
                nextQuestion($('.application .questions-wrapper'), false);
            }, 500);
            return false;
        }
    
        nextQuestion($('.application .questions-wrapper'), false);
    } else {
        element.remove();
        console.log('remove loading');
    }
}

function generateQuestions(questions, location) {
    // console.log('load questions', questions, location);

    // create the loading element
    var loading = $('<div>', {
        class: 'question loading',
        'data-question': '',
        'data-validate': '',
        'data-validations': '[]',
        html: `<div class="question-wrapper">
            <div class="shimmer-wrapper">
                <div class="shimmer title"></div>
            </div>

            <div class="shimmer-wrapper">
                <div class="shimmer paragraph"></div>
            </div>

            <div class="shimmer-wrapper">
                <div class="shimmer paragraph"></div>
            </div>
        </div>`
    });


    switch (location) {
        case 'next':
            // add the loaing next on the list
            $('.question.active').after(loading);
            break;

        case 'end':
            // add the loading to the end
            $('.question').last().after(loading);
            break;
    }

    // set the loading position
    TweenMax.set(loading, { x: $('.questions-wrapper').width() });

    $.ajax({
        type: 'GET',
        url: questions,
        data: {},
        dataType: 'json',
        success: function (data) {
            // console.log(data);

            if (!data.questions) {
                if (sliding) {
                    setTimeout(() => {
                        previousQuestion($('.application .questions-wrapper'));
                    }, 500);
                    return false;
                }

                previousQuestion($('.application .questions-wrapper'));
                return false;
            }

            addQuestions(data.questions, loading, location);
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}


function processSuggestion(question, e) {
    var suggestion = $('.suggestion', question);

    switch(e.keyCode) {
        case 38:
            if (!$('.select-value.selected', suggestion).length) {
                $('.select-value', suggestion).last().addClass('selected');
                return false;
            }

            if ($('.select-value.selected', suggestion).parents('li').is(':first-child')) {
                $('.select-value.selected', suggestion).removeClass('selected');
                $('.select-value', suggestion).last().addClass('selected');
                return false;
            }

            if ($('.select-value.selected', suggestion).parents('li').prev().length) {
                var prev = $('.select-value.selected', suggestion).parents('li').prev();
                $('.select-value.selected', suggestion).removeClass('selected');
                $('.select-value', prev).addClass('selected');
                return false;
            }
            break;
        case 40:
            if (!$('.select-value.selected', suggestion).length) {
                $('.select-value', suggestion).first().addClass('selected');
                return false;
            }

            if ($('.select-value.selected', suggestion).parents('li').is(':last-child')) {
                $('.select-value.selected', suggestion).removeClass('selected');
                $('.select-value', suggestion).first().addClass('selected');
                return false;
            }

            if ($('.select-value.selected', suggestion).parents('li').next().length) {
                var next = $('.select-value.selected', suggestion).parents('li').next();
                $('.select-value.selected', suggestion).removeClass('selected');
                $('.select-value', next).addClass('selected');
                return false;
            }
            break;

        case 13:    
            if ($('.select-value.selected', suggestion).length) {
                // set the value to selected one
                var selected = $('.select-value.selected', suggestion);
                $('input', suggestion).val(selected.attr('data-value'));
                
                // reset the height
                $('.suggestions ul', question).html('');
                TweenMax.set($('.application .questions-wrapper'), {
                    height: question.innerHeight()
                });
                return false;
            }

            if (!$('.select-value', suggestion).length) {
                return true;
            }

            break;
    }

    if ($('input', question).val().length >= parseInt(suggestion.attr('data-suggest_after'))) {
        $.ajax({
            type: 'GET',
            url: suggestion.attr('data-suggestion'),
            data: {
                search: $('input', question).val()
            },
            dataType: 'json',
            success: function (data) {
                // console.log(data);
                $('.suggestions ul', question).html('');
                TweenMax.set($('.application .questions-wrapper'), {
                    height: question.innerHeight()
                });

                $.each(data.values, function(index, value) {
                    $('.suggestions ul', question).append(`<li><a href="" class="select-value" data-value="${value.value}">${value.value}</a></li>`);
                });

                TweenMax.set($('.application .questions-wrapper'), {
                    height: question.innerHeight() + $('.suggestions', question).height()
                });
            },
            error: function (request) {
                console.log(request.responseText);
            }
        });
    }

    return true;
}

$('body').on('click', '.select-value', function() {
    var $this = $(this);
    var question = $this.parents('.question');
    var suggestion = $('.suggestion', question);
    $('input', suggestion).val($this.attr('data-value'));

    $('.suggestions ul', question).html('');
    TweenMax.set($('.application .questions-wrapper'), {
        height: question.innerHeight()
    });
    
    return false;
});

// focus on the input
$('body').on('click', '.placeholder-icon', function() {
    var $this = $(this);
    var input = $this.parents('.input, .phone, .credit-card, .expiry, .cvv, .suggestion');
    $('input', input).focus();
    return false;
});

// cancel the input
$('body').on('click', '.cancel-input', function() {
    var $this = $(this);
    var input = $this.parents('.input, .phone, .credit-card, .expiry, .cvv, .suggestion');
    $('input', input).val('');
    $('input', input).blur();
    validateInput(input);
    return false;
});

$('body').on('click', '.input-next-question', function() {
    $('.application .next-question').trigger('click');
    return false;
});

$('body').on('keyup', '.application input', function(e) {
    var $this = $(this);

    if ($this.parents('.suggestion').length) {
        if(!processSuggestion($this.parents('.question'), e)) {
            e.preventDefault();
            return false;
        }
    }

    if (e.keyCode == 13) {
        if ($this.parents('.question').hasClass('success')) {
            $this.blur();
            $('.application .next-question').trigger('click');
            return false;
        }
    }

    validateInput($this.parents('.input, .phone, .credit-card, .expiry, .cvv, .suggestion'));
    return false;
});


// a custom select question
function validateCustomSelect(select) {
    console.log('validate custom select');
    var question = select.parents('.question');
    var selected = $('.select-option', select);

    question.removeClass('error');
    question.removeClass('success');

    if(question.attr('data-validate')) {
        var validations = JSON.parse(question.attr('data-validations'));
        
        // loop through the validation errors 
        $.each(validations, function(index, validation) {
            // console.log(validation);
            // reset the question error/success
            question.removeClass('error');
            question.removeClass('success');

            // if we have a required validation 
            if(validation.required) {
                if(!selected.length) {
                    if (validation.error) {
                        if (validation.error_message) {
                            question.addClass('error');
                            // question.find('.message').html(validation.error_message);
                        }
                        return false;
                    }
                }

                if (validation.success) {
                    question.addClass('success');
                    // question.find('.message').html(validation.success_message);
                }
            }
        });
    }

    if(selected.length) {
        question.addClass('success');

        // if we need to go auto next
        if(select.attr('data-auto_next')) {
            $('.application .next-question').trigger('click');
        }
    }
}
$('body').on('click', '.application .custom-select .select-all-options', function() {
    var $this = $(this);
    var select = $this.parents('.custom-select');
    // var question = $this.parents('.question');

    // if this is selected remove the selected
    if($this.hasClass('selected')) {
        $this.removeClass('selected');
        $('.select-option', select).removeClass('selected');
        validateCustomSelect(select);
        return false;
    }

    // add the selected class to this option
    $this.addClass('selected');
    $('.select-option', select).addClass('selected');
    validateCustomSelect(select);
    return false;
});

$('body').on('click', '.application .custom-select .select-option', function() {
    var $this = $(this);
    var select = $this.parents('.custom-select');
    // var question = $this.parents('.question');

    // if this is selected remove the selected
    if($this.hasClass('selected')) {
        $this.removeClass('selected');
        validateCustomSelect(select);
        return false;
    }

    // if this is not a multiple selector remvoe the current ones
    if(!select.attr('data-multiple') && $('.select-option.selected', select).length) {
        $('.select-option', select).removeClass('selected');
    }

    // add the selected class to this option
    $this.addClass('selected');
    validateCustomSelect(select);
    return false;
});



// select question
function validateSelect(select) {
    console.log('validate select');
    var question = select.parents('.question');
    var selected = $('option:selected', select);

    question.removeClass('error');
    question.removeClass('success');

    if(question.attr('data-validate')) {
        var validations = JSON.parse(question.attr('data-validations'));
        
        // loop through the validation errors 
        $.each(validations, function(index, validation) {
            // console.log(validation);
            // reset the question error/success
            question.removeClass('error');
            question.removeClass('success');

            // if we have a required validation 
            if(validation.required) {
                if(!selected.val()) {
                    if (validation.error) {
                        if (validation.error_message) {
                            question.addClass('error');
                            // question.find('.message').html(validation.error_message);
                        }
                        return false;
                    }
                }

                if (validation.success) {
                    question.addClass('success');
                    // question.find('.message').html(validation.success_message);
                }
            }
        });
    }

    if(selected.val()) {
        question.addClass('success');

        if(select.attr('data-auto_next')) {
            $('.application .next-question').trigger('click');
        }
    }
}
$('body').on('change', '.application .select select', function() {
    var $this = $(this);
    var select = $this.parents('.select');
    validateSelect(select);
    return false;
});


// select option with keyup
$('body').on('keyup', function (e) {
    var char = String.fromCharCode(e.which);
    if ($('.question.active .select-option[data-shortcut="' + char + '"], .question.active .select-all-options[data-shortcut="' + char + '"]').length) {
        var option = $('.question.active .select-option[data-shortcut="' + char + '"], .question.active .select-all-options[data-shortcut="' + char + '"]');
        option.trigger('click');
    }

    if(e.keyCode == 13 && $('.question.active').hasClass('success')) {
        $('.application .next-question').trigger('click');
    }
});


$('body').on('click', '.application .next-question', function() {
    var question = $('.application .question.active');

    // add the input to the payload
    if(question.find('input').length) {
        payload[question.find('input').attr('name')] = question.find('input').val();
    }

    // add the custom select to the payload
    if(question.find('.custom-select').length) {
        var customSelect = question.find('.custom-select');
        if(customSelect.attr('data-multiple')) {
            var customSelectValues = [];
            $('.select-option.selected', customSelect).each(function() {
                var $this = $(this);
                customSelectValues.push($this.attr('data-value'));

                if ($this.attr('data-generate_questions')) {
                    generateQuestions($this.attr('data-generate_questions'), $this.attr('data-questions_location'));
                }
            });
            payload[customSelect.attr('data-name')] = customSelectValues;
        } else {
            payload[customSelect.attr('data-name')] = $('.select-option.selected', customSelect).attr('data-value');

            if ($('.select-option.selected', customSelect).attr('data-generate_questions')) {
                generateQuestions($('.select-option.selected', customSelect).attr('data-generate_questions'), $('.select-option.selected', customSelect).attr('data-questions_location'));
            }
        }
    }

    // if we have a select option
    if(question.find('select').length) {
        var select = question.find('.select select');
        var option = $('option:selected', select);

        payload[option.attr('name')] = select.val();

        if (option.attr('data-generate_questions')) {
            generateQuestions(option.attr('data-generate_questions'), option.attr('data-questions_location'));
        }
    }

    // // if we have a calendar question 
    if(question.find('.calendar').length) {
        // console.log('calendar');
    }

    // update the progress
    updateQuestionProgress();

    nextQuestion($('.application .questions-wrapper'));
    return false;
});

$('body').on('click', '.application .previous-question', function() {
    previousQuestion($('.application .questions-wrapper'));
    return false;
});





// choose-trip

$('body').on('click', '.choose-trip', function() {
    var $this = $(this);

    $('.explore-trips').attr('data-next', '');
    $('.explore-trips').attr('data-trip', '');

    if($this.parents('.question').length) {
        // if we are selecting from within a question
        $('.explore-trips').attr('data-next', true);
    }

    openModal('.explore-trips');
    return false;
});

$('body').on('click', '.select-trip', function() {
    var $this = $(this);
    closeModal();

    if ($('.chosen-trips .trip').length == 3) {
        $('.chosen-trips .trip').last().remove();
    }
    
    var trip = $('<a>', {
        class: 'trip view-trip-details',
        href: '',
        'data-trip': $this.attr('data-trip'),
        'data-image': $this.attr('data-image'),
        'data-title': $this.attr('data-title'),
        'data-category': $this.attr('data-category'),
        'data-organizer': $this.attr('data-organizer'),
        'data-features': $this.attr('data-features'),
        'html': `<div class="card">
            <header>
                <div class="background-image">
                    <img src="${$this.attr('data-image')}" alt="background">
                </div>

                <div class="trip-heading">
                    <div class="category">${$this.attr('data-category')}</div>
                    <h1 class="title">${$this.attr('data-title')}</h1>
                </div>
            </header>

            <div class="details">
                <ul>
                    <li>
                        <div class="icon icon-calendar"></div>
                        <span>JUN 2 - JUN 12</span>
                    </li>

                    <li>
                        <div class="icon icon-trip"></div>
                        <span>NEW YORK</span>
                    </li>

                    <li>
                        <div class="icon icon-user-small"></div>
                        <span>18 - 22</span>
                    </li>

                    <li>
                        <div class="icon icon-bus"></div>
                        <span>${$this.attr('data-organizer')}</span>
                    </li>
                </ul>
            </div>
        </div>`
    });
    if ($('.explore-trips').attr('data-trip')) {
        $('.chosen-trips .trip[data-trip="' + $('.explore-trips').attr('data-trip') + '"]').replaceWith(trip);
    } else {
        $('.chosen-trips').append(trip);
    }

    $('.chosen-trips h3').show();

    $('aside.main .choose-trip').show();
    if ($('.chosen-trips .trip').length == 3) {
        $('aside.main .choose-trip').hide();
    }

    if ($('.explore-trips').attr('data-next')) {
        $('.application .next-question').trigger('click');
    }
    return false;
});

$('body').on('click', '.view-trip-details', function() {
    var $this = $(this);
    openModal('.trip-details');

    $('.trip-details').attr('data-trip', $this.attr('data-trip'));
    $('.trip-details .intro img').attr('src', $this.attr('data-image'));
    $('.trip-details .category').html($this.attr('data-category'));
    $('.trip-details .organizer').html($this.attr('data-organizer'));
    $('.trip-details .title').html($this.attr('data-title'));
    $('.trip-details .features').html($this.attr('data-features'));
    return false;
});

$('body').on('click', '.delete-trip', function() {
    var $this = $(this);
    var tripID = $this.parents('.trip-details').attr('data-trip');

    $('.chosen-trips .trip[data-trip="'+tripID+'"]').remove();
    $('aside.main .choose-trip').show();
    closeModal();
    return false;
});

$('body').on('click', '.replace-trip', function() {
    var $this = $(this);
    var tripID = $this.parents('.trip-details').attr('data-trip');

    $('.explore-trips').attr('data-next', '');
    $('.explore-trips').attr('data-trip', tripID);

    closeModal();
    openModal('.explore-trips');
    
    return false;
});

$('body').on('click', '.open-trip-cart', function() {
    $(this).addClass('opened');
    $('.application aside.main').addClass('visible');
    closeDropdown();
    return false;
});

$('body').on('click', '.close-trip-cart', function() {
    $('.application aside.main').removeClass('visible');
    $('.open-trip-cart').removeClass('opened');
    return false;
});

$('body').on('keydown keyup', '.auto-expand', function() {
    var $this = $(this);
    // var rows = Math.ceil(($this[0].scrollHeight - 26) / 20);
    // console.log($this[0].scrollHeight, $this[0].scrollHeight/20);
    var rows = Math.ceil(($this[0].scrollHeight - 20) / 20);
    $this.attr('rows', rows > 1 ? rows : 2);

    TweenMax.set($('.application .questions-wrapper'), {
        height: ($('.application .questions-wrapper .active').innerHeight())
    });
});